$(document).ready(function() {

    var headerHeight = $('#header').outerHeight();
    $('.bg_model').css('margin-top', headerHeight + 'px');


    if ($("#range360").length) {
        var pageModel = $('#container360 .model').val();
        var imgCar360webp = $("#container360 picture source");
        var imgCar360 = $("#container360 img");

        function preloadImages() {
            var supportsWebP = (function() {
                var elem = document.createElement('canvas');
                if (!!(elem.getContext && elem.getContext('2d'))) {
                    return elem.toDataURL('img/webp').indexOf('data:image/webp') === 0;
                }
                return false;
            })();

            var selectedColor = $(".color-option.selected img").attr("rel");

            for (var i = 1; i <= 36; i++) {
                var imageUrlPng = "/img/models/" + pageModel + "/360deg/" + selectedColor + "/" + i + ".png";
                var imageUrlWebp = "/img/models/" + pageModel + "/360deg_webp/" + selectedColor + "/" + i + ".webp";

                if (supportsWebP) {
                    $('<img/>').attr('src', imageUrlWebp);
                } else {
                    $('<img/>').attr('src', imageUrlPng);
                }
            }
        }


        function rotateModel() {
            var range360 = $("#range360").val();
            var selectedColor = $(".color-option.selected img").attr("rel");
            var imageUrlPng = "/img/models/" + pageModel + "/360deg/" + selectedColor + "/" + range360 + ".png";
            var imageUrlWebp = "/img/models/" + pageModel + "/360deg_webp/" + selectedColor + "/" + range360 + ".webp";
            imgCar360.attr("src", imageUrlPng);
            imgCar360webp.attr("srcset", imageUrlWebp);
        }

        $(".color-option").on("click", function() {
            $(".color-option").removeClass("selected");
            $(this).addClass("selected");
            preloadImages();
            rotateModel();
        });

        $("#range360").on("input", rotateModel);


        preloadImages();
    }


    if ($('#noSliderBlock').length > 0) {


        $(window).scroll(function() {

            var loc = $('#noSliderBlock').offset().top;
            var scrollLoc = $(window).scrollTop() + $(window).height() / 2;

            if (scrollLoc > loc) {
                $('#noSliderBlock').addClass('show');
            }
        });
    }


    if ($('.dynamic_slider').length > 0) {
        var screenWidth = window.innerWidth;
        var dynamic_slider;


        var dynamic_slider = tns({
            autoHeight: true,
            container: '.dynamic_slider',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".dynamic_slider_nav"

        });


        // var ShowSlice = function(info, eventName) {
        //     var activeSlide = $('.dynamic_slider .tns-slide-active');
        //     var ShowSlicetxt = activeSlide.find('.txt-slice');

        //     if (activeSlide.length > 0) {
        //         ShowSlicetxt.addClass('show');
        //     } else {
        //         ShowSlicetxt.removeClass('show');
        //     }
        // }
        // dynamic_slider.events.on('transitionEnd', ShowSlice);


        // $(window).scroll(function() {

        //     var loc = $('#txt-slice').offset().top;
        //     var scrollLoc = $(window).scrollTop() + $(window).height();

        //     if (scrollLoc > loc) {
        //         $('#txt-slice').addClass('show');
        //     }
        // });

    }

    if ($('#stylingSlider').length > 0) {

        var stylingSlider = tns({
            container: '#stylingSlider',
            items: 1,
            slideBy: 1,
            loop: true,
            nav: true,
            mouseDrag: true,
            mode: 'gallery',
            navContainer: '.stylingSlider_nav',
            prevButton: '.stylingSlider_prev',
            nextButton: '.stylingSlider_next',
            speed: 500
        });

        var ShowText = function(info, eventName) {
            var activeSlide = $('#stylingSlider .tns-slide-active');
            var TextClass = $('.styling .' + activeSlide.attr('data-slide'));
            var sliderTxt = $('.styling .text_slider');

            var sliders = $(".styling .text_slider");
            sliders.css('display', 'none');
            $(".styling ."+activeSlide.attr('data-slide')).css('display', 'block');

            if (activeSlide.length > 0) {
                console.log('THe activeSlide.lendgth > 0')
                sliderTxt.css('display', 'none');

                TextClass.fadeIn();

            }
        }
        stylingSlider.events.on('transitionStart', ShowText);

    }


    if ($('.second_dynamic_slider').length > 0) {


        var second_dynamic_slider = tns({
            container: '.second_dynamic_slider',
            autoHeight: true,
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".second_dynamic_slider_nav"

        });


        // var ShowSlice = function(info, eventName) {
        //     var activeSlide = $('.second_dynamic_slider .tns-slide-active');
        //     var ShowSlicetxt = activeSlide.find('.txt-slice');

        //     if (activeSlide.length > 0) {
        //         ShowSlicetxt.addClass('show');
        //     } else {
        //         ShowSlicetxt.removeClass('show');
        //     }
        // }
        // second_dynamic_slider.events.on('transitionEnd', ShowSlice);

        // if ($('#txt-slice2').length > 0) {
        //     $(window).scroll(function() {

        //         var loc = $('#txt-slice2').offset().top;
        //         var scrollLoc = $(window).scrollTop() + $(window).height();

        //         if (scrollLoc > loc) {
        //             $('#txt-slice2').addClass('show');
        //         }
        //     });
        // }

    }

    if ($('#interiorSlider').length > 0) {

        var interiorSlider = tns({
            container: '#interiorSlider',
            items: 1,
            slideBy: 1,
            loop: true,
            nav: true,
            mouseDrag: true,
            mode: 'gallery',
            navContainer: '.interiorSlider_nav',
            prevButton: '.interiorSlider_prev',
            nextButton: '.interiorSlider_next',
            speed: 500
        });

        var ShowText = function(info, eventName) {
            var activeSlide = $('#interiorSlider .tns-slide-active');
            var TextClass = $('.interior .' + activeSlide.attr('data-slide'));
            var sliderTxt = $('.interior .text_slider');

            if (activeSlide.length > 0) {
                console.log('THe activeSlide.lendgth > 0')
                sliderTxt.css('display', 'none');

                TextClass.fadeIn();
            }
        }
        interiorSlider.events.on('transitionStart', ShowText);

    }


    /*Color_BLOCK__*/

    $(".change_color").click(function() {
        var targetMini = $('.' + $(this).attr('target'));

        $('.img_model_get').css('z-index', '2');
        $('.img_model_get').css({ opacity: 0, transition: 'opacity 1s' });

        targetMini.css({ opacity: 1, transition: 'opacity 0s' });
        targetMini.css('z-index', '1');

        $('.change_color').removeClass('active');
        $(this).addClass('active');
    });


    if ($('.comfort_slider').length > 0) {

        var comfort_slider = tns({
            container: '.comfort_slider',
            items: 1,
            slideBy: 1,
            loop: true,
            nav: true,
            mouseDrag: true,
            autoHeight: true,
            navContainer: '.comfort_slider_nav',
            nextButton: '.comfortSlider_next',
            prevButton: '.comfortSlider_prev',
            speed: 800
        });

        var ShowText = function(info, eventName) {
            var activeSlide = $('.comfort_slider .tns-slide-active');
            var TextClass = $('.comfort_txt .' + activeSlide.attr('data-slide'));
            var sliderTxt = $('.comfort_txt .text_slider');
            if (activeSlide.length > 0) {
                console.log('THe activeSlide.lendgth > 0')
                sliderTxt.css('display', 'none');

                TextClass.fadeIn();
            }
        }
        comfort_slider.events.on('transitionStart', ShowText);
    }


    if ($('#safetySlider').length > 0) {

        var safetySlider = tns({
            container: '#safetySlider',
            items: 1,
            slideBy: 1,
            loop: true,
            nav: true,
            mouseDrag: true,
            mode: 'gallery',
            navContainer: '.safetySlider_nav',
            prevButton: '.safetySlider_prev',
            nextButton: '.safetySlider_next',
            speed: 500
        });

        var ShowText = function(info, eventName) {
            var activeSlide = $('#safetySlider .tns-slide-active');
            var TextClass = $('.safety .' + activeSlide.attr('data-slide'));
            var sliderTxt = $('.safety .text_slider');

            if (activeSlide.length > 0) {
                console.log('THe activeSlide.lendgth > 0')
                sliderTxt.css('display', 'none');

                TextClass.fadeIn();
            }
        }
        safetySlider.events.on('transitionStart', ShowText);

    }

    if ($('.modelGalery').length > 0) {
        var modelGalery = tns({
            container: '.modelGalery',
            autoplay: true,
            items: 1,
            edgePadding: 50,
            swipeAngle: 0,
            center: true,
            gutter: 10,
            loop: true,
            navContainer: '.modelGalery_nav',
            autoplayButtonOutput: false,
            controls: false,
            preventActionWhenRunning: true,
            speed: 800,
            responsive: {
                "998": {
                    gutter: 30,
                    edgePadding: 350
                }
            }
        });
    }
});


$(document).ready(function() {
    if ($('.apple_scrol').length > 0) {


        var isCardVisible = [true, false]; // Tablica przechowująca informacje o widoczności każdego slajdu
        var matrixElements = [
            $('.apple_scrol .matrix-first'),
            $('.apple_scrol .matrix-second')
        ];

        var halfWindowHeight = $(window).height();

        var initialTranslateY = [70, 70, 70];

        $(window).scroll(function() {
            var appleScrolTop = $('.apple_scrol').offset().top;
            var scrollPos = $(window).scrollTop();

            if (scrollPos >= appleScrolTop) {
                for (var i = 0; i < 2; i++) {

                    if (scrollPos >= appleScrolTop + halfWindowHeight * i && !isCardVisible[i]) {
                        $('.apple_scrol .dynamic_card.card' + (i + 1)).css('display', 'block');
                        isCardVisible[i] = true;

                        for (var j = 0; j < 2; j++) {
                            if (j !== i) {

                                $('.apple_scrol .dynamic_card.card' + (j + 1)).css('display', 'none');
                                isCardVisible[j] = false;
                            }
                        }
                    }

                    var maxScroll = 1.5 * $(window).height();
                    var scrollPercentage = ((scrollPos - appleScrolTop - halfWindowHeight * i) / maxScroll) * 100;

                    var translateY = initialTranslateY[i] - (scrollPercentage * 1.4);
                    translateY = Math.min(Math.max(translateY, -70), 70);

                    var opacity;
                    if ((scrollPercentage >= 0 && scrollPercentage <= 10) || (scrollPercentage >= 90 && scrollPercentage <= 100)) {
                        opacity = 0.7;
                    } else {
                        opacity = 1;
                    }

                    matrixElements[i].css({
                        'transform': 'matrix(1, 0, 0, 1, 0, ' + translateY + ')',
                        'opacity': opacity
                    });
                }
            }
        });


    }
});


$(document).ready(function() {
    if ($('.apple_scrol2').length > 0) {

        var isCardVisible = [true, false, false, false]; // Tablica przechowująca informacje o widoczności każdego slajdu
        var matrixElements = [
            $('.apple_scrol2 .matrix-first'),
            $('.apple_scrol2 .matrix-second'),
            $('.apple_scrol2 .matrix-third'),
            $('.apple_scrol2 .matrix-fourth')
        ];

        var halfWindowHeight = $(window).height();

        var initialTranslateY = [70, 70, 70];
        if ( $('.apple_scrol2 .matrix-fourth').length > 0) {
            initialTranslateY = [70, 70, 70, 70];
        }
        $(window).scroll(function() {
            var appleScrolTop = $('.apple_scrol2').offset().top;
            var scrollPos = $(window).scrollTop();
            let counter = initialTranslateY.length;

            if (scrollPos >= appleScrolTop) {
                for (var i = 0; i < counter; i++) {

                    if (scrollPos >= appleScrolTop + halfWindowHeight * i && !isCardVisible[i]) {
                        $('.apple_scrol2 .dynamic_card.card' + (i + 1)).css('display', 'block');
                        isCardVisible[i] = true;

                        for (var j = 0; j < counter; j++) {
                            if (j !== i) {
                                $('.apple_scrol2 .dynamic_card.card' + (j + 1)).css('display', 'none');
                                isCardVisible[j] = false;
                            }
                        }
                    }

                    var maxScroll = counter * $(window).height();
                    var scrollPercentage = ((scrollPos - appleScrolTop - halfWindowHeight * i) / maxScroll) * 100;

                    var translateY = initialTranslateY[i] - (scrollPercentage * 1.4);
                    translateY = Math.min(Math.max(translateY, -70), 70);

                    // Adjusting the opacity calculation to ensure smoother transitions
                    var opacity = 1; // Start with full opacity
                    if (scrollPercentage >= 0 && scrollPercentage <= 10) {
                        opacity = 0.7 + scrollPercentage * 0.03; // Gradually increase opacity at the start
                    } else if (scrollPercentage > 90) {
                        opacity = 1.3 - (scrollPercentage * 0.03); // Gradually decrease opacity towards the end
                    }

                    // Ensure opacity does not drop below a minimum threshold to avoid content disappearing too much
                    opacity = Math.max(opacity, 0.4);

                    matrixElements[i].css({
                        'transform': 'matrix(1, 0, 0, 1, 0, ' + translateY + ')',
                        'opacity': opacity
                    });
                }
            }
        });
    }
});


/*OFF_ROAD MODELS--*/

/*OFF_ROAD MODELS--*/

function setupSlider($slider) {
    var $dynamicCards = $slider.find('.dynamic_card');
    var numCards = $dynamicCards.length;

    var wrapperHeight = 'calc(' + ((numCards * 100) + 100) + 'vh - 100px)';
    $slider.find('.wrapper').css('height', wrapperHeight);

    var isCardVisible = new Array(numCards).fill(false);
    var matrixElements = [];

    for (var i = 0; i < numCards; i++) {
        matrixElements.push($slider.find('.matrix-' + (i + 1)));
    }

    var halfWindowHeight = $(window).height();
    var initialTranslateY = new Array(numCards).fill(70);

    $(window).scroll(function() {
        var sliderTop = $slider.offset().top;
        var scrollPos = $(window).scrollTop();

        if (scrollPos >= sliderTop) {
            for (var i = 0; i < numCards; i++) {
                if (scrollPos >= sliderTop + halfWindowHeight * i && !isCardVisible[i]) {
                    $dynamicCards.eq(i).css('display', 'block');
                    isCardVisible[i] = true;

                    for (var j = 0; j < numCards; j++) {
                        if (j !== i) {
                            $dynamicCards.eq(j).css('display', 'none');
                            isCardVisible[j] = false;
                        }
                    }
                }

                var maxScroll = numCards * $(window).height();
                var scrollPercentage = ((scrollPos - sliderTop - halfWindowHeight * i) / maxScroll) * 100;
                var translateY = initialTranslateY[i] - (scrollPercentage * 1.4);
                translateY = Math.min(Math.max(translateY, -70), 70);

                var opacity;
                if ((scrollPercentage >= 0 && scrollPercentage <= 10) || (scrollPercentage >= 90 && scrollPercentage <= 100)) {
                    opacity = 0.7;
                } else {
                    opacity = 1;
                }

                matrixElements[i].css({
                    'transform': 'matrix(1, 0, 0, 1, 0, ' + translateY + ')',
                    'opacity': opacity
                });
            }
        }
    });
}


$(document).ready(function() {

    var header = $('#header');
    var menu = $('#bj_model_menu');

    if ($('#bj_model_menu').length) {
        var menuOffset = menu.offset().top - header.outerHeight();
    }

    $(window).scroll(function() {
        var scrollPos = $(window).scrollTop();
        if (scrollPos >= menuOffset) {
            header.addClass('bj_model_page');
            menu.addClass('sticky');
        } else {
            header.removeClass('bj_model_page');
            menu.removeClass('sticky');
        }
    });

    var bannerOffsetTop = 0
    var bannerHeight = 0;
    var scrollTarget = 0;

    if ($('.index_banner').length) {
        var bannerOffsetTop = $('.index_banner').offset().top;
        var bannerHeight = $('.index_banner').outerHeight();
        var scrollTarget = bannerOffsetTop + bannerHeight;
    }

    $('.btn_bj_menu').click(function(event) {
        $('.btn_bj_menu').removeClass('active');
        $(this).addClass('active');
        $('.bj_content').fadeOut();

        var sectionContent = $('.' + $(this).attr('id'));
        sectionContent.fadeIn(function() {
            if ($(window).width() > 992) {
                var bannerOffsetTop = $('.index_banner').offset().top;
                var bannerHeight = $('.index_banner').outerHeight();
                var scrollTarget = bannerOffsetTop + bannerHeight;

                window.scrollTo({
                    top: scrollTarget,
                    behavior: 'instant'
                });

                var startBlock = sectionContent.find('.dynamic_card').first();
                startBlock.css('display', 'block');
                startBlock.find('.matrix').css({
                    'transform': 'matrix(1, 0, 0, 1, 0, 70)',
                    'opacity': '0.7'
                });
            } else {
                sliderBJOffRoad?.refresh();
                sliderBJStyle?.refresh();
                sliderBJSecurity?.refresh();
                sliderBJMultimedia?.refresh();
                sliderBJDrive?.refresh();
                sliderBJRallies?.refresh();
            }
        });


    });

    $('.apple_scrol_bj').each(function() {
        setupSlider($(this));
    });


    if ($('.bj_content').length > 0) {
        var sliderBJOffRoad = tns({
            autoHeight: true,
            container: '#sliderBJOffRoad',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJOffRoad_nav"
        });

        var sliderBJStyle = tns({
            autoHeight: true,
            container: '#sliderBJStyle',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJStyle_nav"
        });

        var sliderBJSecurity = tns({
            autoHeight: true,
            container: '#sliderBJSecurity',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJSecurity_nav"
        });

        var sliderBJMultimedia = tns({
            autoHeight: true,
            container: '#sliderBJMultimedia',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJMultimedia_nav"
        });

        var sliderBJDrive = tns({
            autoHeight: true,
            container: '#sliderBJDrive',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJDrive_nav"
        });

        var sliderBJRallies = tns({
            autoHeight: true,
            container: '#sliderBJRallies',
            items: 1,
            controls: false,
            nav: true,
            speed: 1000,
            navContainer: ".sliderBJRallies_nav"
        });

        if ($('#sliderBJInterior').length > 0) {
            var sliderBJInterior = tns({
                autoHeight: true,
                container: '#sliderBJInterior',
                items: 1,
                controls: false,
                nav: true,
                speed: 1000,
                navContainer: ".sliderBJRallies_nav"
            });
        }
        if ($('#sliderBJEquipment').length > 0) {
            var sliderBJEquipment = tns({
                autoHeight: true,
                container: '#sliderBJEquipment',
                items: 1,
                controls: false,
                nav: true,
                speed: 1000,
                navContainer: ".sliderBJEquipment_nav"
            });
        }
         if ($('#sliderBJ4x4').length > 0) {
            var sliderBJ4x4 = tns({
                autoHeight: true,
                container: '#sliderBJ4x4',
                items: 1,
                controls: false,
                nav: true,
                speed: 1000,
                navContainer: ".sliderBJ4x4_nav"
            });
        }
    }
});
